import React, { useState } from "react";
import { testimonials } from "../../mock";
import { ArrowLeft, ArrowRight } from "lucide-react";

const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  const prev = () => setActive((a) => (a === 0 ? testimonials.length - 1 : a - 1));
  const next = () => setActive((a) => (a === testimonials.length - 1 ? 0 : a + 1));

  return (
    <section id="testimonials" className="bg-[#0d0d0d] text-white">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative min-h-[400px] lg:min-h-[720px] overflow-hidden">
          {testimonials.map((item, i) => (
            <img
              key={i}
              src={item.image}
              alt={item.name}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
                i === active ? "opacity-100" : "opacity-0"
              }`}
            />
          ))}
          <div className="absolute inset-0 bg-black/20" />
        </div>

        <div className="flex flex-col justify-center px-8 md:px-20 py-20">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-8">You&rsquo;re in Good Company</p>
          <div className="min-h-[260px] md:min-h-[300px]">
            <blockquote className="font-serif-display text-2xl md:text-[2rem] font-light leading-relaxed text-white/90">
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <div className="mt-8">
              <p className="font-serif-display text-xl text-white">&mdash; {t.name}</p>
              <p className="text-white/50 text-[12px] tracking-luxe-sm uppercase mt-1">{t.role}</p>
            </div>
          </div>

          <div className="flex items-center gap-6 mt-12">
            <button onClick={prev} className="w-12 h-12 border border-white/25 flex items-center justify-center hover:bg-white hover:text-black transition-colors" aria-label="Previous">
              <ArrowLeft size={18} />
            </button>
            <button onClick={next} className="w-12 h-12 border border-white/25 flex items-center justify-center hover:bg-white hover:text-black transition-colors" aria-label="Next">
              <ArrowRight size={18} />
            </button>
            <span className="text-white/50 text-[12px] tracking-luxe-sm ml-2">
              {String(active + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
